export default {
    GET_SR_DATA: 'GET_SR_DATA',
    SR_DATA:'SR_DATA',
    GET_SSP_SR_VIEW: 'GET_SSP_SR_VIEW',
    SSP_SR_VIEW: 'SSP_SR_VIEW',
    TABS_ORDER: 'TABS_ORDER',
    SR_TYPE_INCIDENT: 1,
    SR_TYPE_REQUEST: 10
}



// WEBPACK FOOTER //
// ./constants/SRview.js